import { triangle } from 'polished';
import * as React from 'react';
import styled from 'styled-components';

import { Collapsible } from './Collapsible';

interface AccordionProps {
	title: string;
	children: React.ReactNode;
}

interface AccordionState {
	isOpen: boolean;
}

export class Accordion extends React.Component<AccordionProps, AccordionState> {
	constructor(props: AccordionProps) {
		super(props);
		this.state = { isOpen: false };
	}

	render() {
		return (
			<Container>
				<Header onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
					<Triangle isOpen={this.state.isOpen} />
					<Title>{this.props.title}</Title>
				</Header>
				<Collapsible isOpen={this.state.isOpen}>{this.props.children}</Collapsible>
			</Container>
		);
	}
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
`;

const Triangle = styled.div<{ isOpen: boolean }>`
	margin-right: 0.5rem;
	${(p) =>
		triangle({
			pointingDirection: 'right',
			width: '.5rem',
			height: '.5rem',
			foregroundColor: p.theme.colors.text.secondary,
		})}
	transition: transform .1s ease-in;
	transform: ${(p) => (p.isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

const Title = styled.div``;
